export default "__VITE_ASSET__Daw1KGmg__"